<template>
  <div class="merchant-info-filter-form custom-wrapper">
    <div class="filter-wrapper">

      <el-form
        label-position="right"
        label-width="80px"
        ref="filterForm"
        :model="filterForm">

        <el-form-item label="入件ID" prop="merchant_id">
          <el-input
            v-model="filterForm.merchant_id"
            placeholder="请输入商户入件ID"
            @keyup.enter.native="onFilterSubmit"></el-input>
        </el-form-item>

        <el-form-item
          label="商户名"
          v-if="hasRes('user_index')"
          prop="userid">
          <el-select
            filterable
            default-first-option
            v-model="filterForm.userid"
            style="width: 100%;">
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="user in userList"
              :key="user.userid"
              :label="user.username"
              :value="user.userid">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="收款人" prop="acct_name">
          <el-input
            v-model="filterForm.acct_name"
            placeholder="请输入收款人姓名"
            @keyup.enter.native="onFilterSubmit"></el-input>
        </el-form-item>

        <el-form-item label="收款账号" prop="acct_cert_no">
          <el-input
            v-model="filterForm.acct_cert_no"
            placeholder="请输入收款账号（输入关键尾号即可，无需输入*）"
            @keyup.enter.native="onFilterSubmit"></el-input>
        </el-form-item>

        <el-form-item label="支付渠道" prop="now_pay_channel">
          <el-select
            v-model="filterForm.now_pay_channel"
            style="width: 100%">
            <el-option label="全部" value=""></el-option>
            <el-option label="扫呗" value="sb"></el-option>
            <el-option label="京东" value="jd"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="扫呗审核" prop="sb_review">
          <el-select
            v-model="filterForm.sb_review"
            style="width: 100%">
            <el-option label="全部" value=""></el-option>
            <el-option :label="reviewEnum[0]" value="0"></el-option>
            <el-option :label="reviewEnum[1]" value="1"></el-option>
            <el-option :label="reviewEnum[2]" value="2"></el-option>
            <el-option :label="reviewEnum[3]" value="3"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="京东审核" prop="jd_review">
          <el-select
            v-model="filterForm.jd_review"
            style="width: 100%">
            <el-option label="全部" value=""></el-option>
            <el-option :label="reviewEnum[0]" value="0"></el-option>
            <el-option :label="reviewEnum[1]" value="1"></el-option>
            <el-option :label="reviewEnum[2]" value="2"></el-option>
            <el-option :label="reviewEnum[3]" value="3"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="商户证件" prop="data_status">
          <el-select
            v-model="filterForm.data_status"
            style="width: 100%">
            <el-option label="全部" value=""></el-option>
            <el-option label="未提交" value="0"></el-option>
            <el-option label="已提交" value="1"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="资料补全" prop="complete_status">
          <el-select
            v-model="filterForm.complete_status"
            style="width: 100%">
            <el-option label="全部" value=""></el-option>
            <el-option label="未补全" value="0"></el-option>
            <el-option label="已补全" value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div class="submit">
        <el-button
          type="danger"
          size="medium"
          @click="onFilterSubmit">查询</el-button>
        <el-button
          size="medium"
          @click="resetFilters">重置</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { SET_PAGE, SET_FILTERS } from '@/store/modules/table'

export default {
  name: 'MerchantInfoFilterForm',
  data () {
    return {
      reviewEnum: ['待完善', '审核中', '审核通过', '审核不通过'],
      protocolEnum: ['未签署', '签署中', '签署成功', '签署失败'],

      filterForm: {
        merchant_id: '',
        userid: '',
        acct_name: '',
        acct_cert_no: '',
        now_pay_channel: '',
        sb_review: '',
        jd_review: '',
        data_status: '',
        complete_status: ''
      }
    }
  },
  computed: {
    ...mapState('user', [
      'userList'
    ]),
    ...mapGetters('opUser', [
      'hasRes'
    ])
  },
  methods: {
    ...mapMutations('table', [
      SET_PAGE,
      SET_FILTERS
    ]),
    ...mapActions('user', [
      'getUsers'
    ]),

    // 过滤相关
    onFilterSubmit () {
      this.setPage(1)
      this.setFilters(this.filterForm)

      this.$emit('filter')
    },
    resetFilters () {
      this.$refs['filterForm'].resetFields()
    }
  },
  mounted () {
    if (this.hasRes('user_index')) {
      this.getUsers({
        page: 1,
        pageSize: 9999
      }).catch(err => {
        console.log(err)
      })
    }

    if ('userid' in this.$route.query) {
      this.filterForm.userid = this.$route.query.userid
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/base";
</style>



// WEBPACK FOOTER //
// src/components/bank/MerchantInfoFilterForm.vue